import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let BrowserNotifier = class BrowserNotifier extends Vue {
    notify(title, body) {
        if (window.Notification && Notification.permission !== 'denied') {
            // status default param - "granted", if accepted by user
            Notification.requestPermission(() => {
                const notifier = new Notification(title, {
                    body,
                    icon: require('@/assets/images/chatgenie_default_avatar.png'),
                });
                notifier.onclick = () => {
                    window.open(this.notifierLink, '_blank');
                };
                return notifier;
            });
        }
    }
    uuidObserver() {
        this.notify(this.notifierTitle, this.message);
    }
};
__decorate([
    Prop({ type: String, default: '' })
], BrowserNotifier.prototype, "message", void 0);
__decorate([
    Prop({ type: String, default: 'Chatgenie Notification' })
], BrowserNotifier.prototype, "notifierTitle", void 0);
__decorate([
    Prop({ type: String, default: '' })
], BrowserNotifier.prototype, "notifierUuid", void 0);
__decorate([
    Prop({ type: String, default: window.location.href })
], BrowserNotifier.prototype, "notifierLink", void 0);
__decorate([
    Watch('notifierUuid')
], BrowserNotifier.prototype, "uuidObserver", null);
BrowserNotifier = __decorate([
    Component
], BrowserNotifier);
export default BrowserNotifier;
